<template>
  <div>
    <!--讲师介绍-->
    <div class="teacher_about_top">
      <!--local-->
      <div class="tit">
        <dl>
          <dt>首页 - 优秀讲师 - 讲师介绍</dt>
          <dd>
            <!--<a title="收藏" class="fav"></a>&lt;!&ndash;当点击变成已收藏，class值变成 fav_focus&ndash;&gt;
            <a title="分享" class="share"></a>-->
          </dd>
        </dl>
      </div>
      <!--/local-->
      <div class="con_about">
        <dl>
          <dt>
            <p>
              <img v-if="params.faceUrl" :src="params.faceUrl" :title="params.name"/>
              <img v-if="!params.faceUrl || params.faceUrl==''" src="@/assets/images/teacher_normal_img.jpg" :title="params.name"/>
            </p>
            <h4>{{params.name}}</h4>
          </dt>
          <dd>{{params.title}}</dd>
        </dl>
      </div>
      <div class="about_other">
        <!--<a class="t_gz">加关注</a><a class="t_gz2" style="display: none;">已关注</a>-->
        <span>{{courseCnt}}</span>课程　　　<!--<span>375</span>粉丝-->
      </div>
      <div class="about_t_con" v-html="params.content"></div>
    </div>
    <!--/讲师介绍-->

    <!--相关课程-->
    <div class="box study_list">
      <div class="wrap w1200">
        <div class="top_tit">
          <h3>相关课程</h3>
          <a href="javascript:;" class="study_prv" title="上一页" @click="page_click('prev')"></a>
          <a href="javascript:;" class="study_next" title="下一页" @click="page_click('next')"></a>
        </div>
        <div class="list">
          <a href="javascript:;" v-for="item in courseList" :key="item.id" @click="course_detail(item.id)">
            <dl>
              <dt>
                <img v-if="item.faceUrl" :src="item.faceUrl" :title="item.name" />
                <img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/class_img.jpg" :title="item.name" />
                <span class="price_r" v-if="item.coursePriceList && item.coursePriceList[0].price && item.coursePriceList[0].price != '0'">￥{{item.coursePriceList[0].price}}</span>
                <span class="price_r" v-if="!item.coursePriceList || !item.coursePriceList[0].price || item.coursePriceList[0].price == '0'">免费</span>
                <span class="man_num_r">{{item.learnCount}}</span>
              </dt>
              <dd>
                <h3>{{item.name}}</h3>
                <p v-if="item.teacherList && item.teacherList.length>0">讲师：{{item.teacherList[0].teacherName}}<span v-if="item.teacherList.length>1">等</span></p>
                <p v-if="!item.teacherList">讲师：暂无</p>
              </dd>
            </dl>
          </a>
        </div>
      </div>
    </div>
    <!--/相关课程-->
    <div class="clear"></div>
  </div>
</template>
<script>
export default {
  components: { },
  data () {
    return {
      params: {},
      filter: {
        pageNo: 1,
        pageSize: 8,
        teacherId: this.$route.params.id,
        delFlag: '0'
      },
      courseList: [],
      courseCnt: 0,
      currentPage: 1,
      pages: 0
    }
  },
  created () {
    this.getTeacherById(this.$route.params.id)
    this.getCourseListByTeacherId(this.filter)
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  computed: {},
  methods: {
    page_click (type) {
      if (type=='prev') {
        if (this.currentPage > 1) {
          this.filter.pageNo = this.currentPage - 1
          this.currentPage--
          this.getCourseListByTeacherId(this.filter)
        }
      } else if (type=='next') {
        if (this.currentPage < this.pages) {
          this.filter.pageNo = this.currentPage + 1
          this.currentPage++
          this.getCourseListByTeacherId(this.filter)
        }
      }
    },
    getTeacherById (id) {
      this.$api.getRestful(this.$global.teacherApiPath, '/teacher/' + id, {}, r => {
        this.params = r.data
      })
    },
    getCourseListByTeacherId (filter) {
      this.$api.post(this.$global.courseApiPath, '/course/teacher', filter, r => {
        if (r.data && r.data.length>0) {
          this.courseCnt = r.cntData
          this.courseList = r.data
          this.pages = Math.ceil(r.cntData / this.filter.pageSize)
        } else {
          this.courseList = []
          this.pages = 0
          this.courseCnt = 0
        }
      })
    },
    course_detail (id) {
      this.$router.push({path: '/byl/courseDetail/'+ id})
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/teacher/detail.vue